<svg viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 11L6.92083 6.16261C6.94573 6.14221 6.96565 6.11717 6.9793 6.08914C6.99294 6.06111 7 6.03073 7 6C7 5.96927 6.99294 5.93889 6.9793 5.91086C6.96565 5.88283 6.94573 5.85779 6.92083 5.83739L1 1" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
